<script setup>
defineProps({
    dataSources: {
        type: String,
        required: true
    }
})

const dialog = ref(false)
</script>
<template>
    <div class="text-right data-sources">
        <v-dialog v-model="dialog" class="data-sources-dialog" width="500">
            <template #activator="{ attrs }">
                <v-btn
                    variant="text"
                    size="x-small"
                    v-bind="attrs"
                    @click="dialog = true"
                    class="text-capitalize"
                >
                    <v-icon size="x-small">mdi-information-slab-circle-outline</v-icon> Data Sources
                    <v-tooltip activator="parent" location="bottom">See data sources</v-tooltip>
                </v-btn>
            </template>
            <v-card class="ds-card">
                <v-btn
                    size="x-small"
                    class="ds-close"
                    fab
                    dark
                    icon="mdi-close"
                    color="black"
                    @click="dialog = false"
                >
                </v-btn>
                <v-card-text class="ds-body">
                    <div class="data-sources-table">
                        <div class="source">
                            <div class="ds-logo">
                                <img src="/images/visuado-logo-vertical.png" />
                            </div>
                            <div class="ds-text">
                                <span class="text-subtitle-1">Project Visualization</span> Interior,
                                building facades, and project side has been visualized by Visuado
                                As.
                            </div>
                        </div>
                        <div class="source">
                            <div class="ds-logo">
                                <img src="/images/google-logo.png" />
                            </div>
                            <div class="ds-text">
                                <span class="text-subtitle-1">Far Scenery</span> The landscape
                                outside of the project site has been generated using
                                <a
                                    href="https://mapsplatform.google.com/maps-products/map-tiles/"
                                    target="_blank"
                                    >Google 3D Tiles</a
                                >.
                            </div>
                        </div>
                        <div class="source">
                            <div class="ds-logo">
                                <img src="/images/data-source.png" />
                            </div>
                            <div class="ds-text">
                                <span class="text-subtitle-1">Data Sources</span> {{ dataSources }}
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
.ds-card.v-card.v-sheet.theme--light {
    background: none !important;
}

.ds-card {
    background: none !important;
    box-shadow: none !important;
    padding: 10px;
}

.ds-body {
    background: #fff;
    border-radius: 10px;
}

.data-sources-table {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 5px;
}

.data-sources-table .source {
    display: flex;
    width: 100%;
    margin: 5px 5px;
}

.ds-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 130px;
    overflow: hidden;
    background: #ededed;
}

.ds-logo img {
    width: 80%;
    height: auto;
}

.ds-text {
    padding-left: 10px;
    width: 100%;
    font-size: 0.8em;
}
span.text-subtitle-1 {
    display: block;
}

.ds-body {
    padding: 0 !important;
}

button.ds-close {
    position: absolute;
    right: 0px;
    top: 0px;
}
</style>
